import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGreenPower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGreenPower"><Path fillRule="evenodd" clipRule="evenodd" d="M5.16101 17.7687C2.13125 13.7222 2.34173 9.272 5.10511 6.23444C7.9505 3.10675 13.303 1.69666 19.9208 3.54964L20.3271 3.66339L20.4408 4.06965C22.2937 10.6875 20.8836 16.04 17.7559 18.8853C14.7184 21.6487 10.2682 21.8591 6.22167 18.8294L3.74816 21.3029L2.6875 20.2423L5.16101 17.7687ZM9.00049 12.5001L13.5005 7.00006V10.5001H16.0005L11.5005 16.0001V12.5001H9.00049Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGreenPower;
